module.exports = __webpack_public_path__ + "static/media/grand-parents.0a6fa36b.png";